import Vue from 'vue'
import App from './App.vue'
import VueTheMask from 'vue-the-mask'
import { createPinia, PiniaVuePlugin } from 'pinia'
import VueSmoothScroll from 'vue2-smooth-scroll'
import { BootstrapVue } from 'bootstrap-vue'

import '@/styles/main.scss'

Vue.config.productionTip = false
Vue.use(PiniaVuePlugin)
Vue.use(BootstrapVue)
Vue.use(VueTheMask)
Vue.use(VueSmoothScroll, { updateHistory: false})

new Vue({
  render: h => h(App),
  pinia: createPinia(),
}).$mount('#app')
